import { ChangeDetectionStrategy, Component } from '@angular/core';

import { DataService } from '@services';
import { AuthStore } from '@store';

@Component({
  selector: 'app-invitation-notification',
  templateUrl: './invitation-notification.component.html',
  styleUrls: ['./invitation-notification.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InvitationNotificationComponent {
  constructor(public dataService: DataService, public authStore: AuthStore) {}
}
